import { render, staticRenderFns } from "./SimpleFilterCriterion.vue?vue&type=template&id=add71a74&"
import script from "./SimpleFilterCriterion.vue?vue&type=script&lang=js&"
export * from "./SimpleFilterCriterion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports